/*globals jQuery */
import { debounce } from '../_debounce';

( function() {
	'use strict';

	// Define global object.
	if ( typeof window.MSR !== 'object' ) {
		window.MSR = {};
	}

	// ACCESSIBLE ANCHOR LINK SCROLLING
	window.MSR.scrollAnchor = ( function( $, undefined ) {
		var config;

		var sections;

		var init = function( settings ) {
			config = {
				target: '.msr-scroll-anchor-link',
				scrollOffsetTop: 30,
				activeOffsetTop: 200,
				activeEl: 'li'
			};

			$.extend( config, settings );

			if ( $( config.target ).length > 0 ) {
				setup();
			}
		};

		var setup = function() {
			var $win = $( window );

			sections = $( config.target ).filter( '[href^=\'#\']:not([href=\'#\'])' ).map( function( i, el ) {
				return new sectionObj( el, config );
			} ).toArray();

			function findCurrent(){
				var current_section = sections[ 0 ],
					last_section = sections.length - 1;

				$.each( sections, function( i, val ) {
					var section = $( val )[ 0 ];

					//calculate offset for this section
					//section.calculateOffset();
					section.activeEl.removeClass( 'active' );
					if ( $win.scrollTop() + $win.height() === $( document ).height() ) {
						current_section = sections[ last_section ];
					} else if ( $win.scrollTop() > ( section.target_offset - config.activeOffsetTop ) ) {
						current_section = section;
					}

				} );

				current_section.activeEl.addClass( 'active' );
			}

			$win.on( 'load', findCurrent() );

			$win.scroll( $.throttle( 100, findCurrent ) );
		};

		var sectionObj = function( el, options ) {
			var self = this,
				$win = $( window );

			this.anchor = $( el );
			this.target = $( this.anchor.attr( 'href' ) );
			this.target_header = this.target.find( 'h2, h3, h4, h5, h6' ).eq( 0 );
			this.focusEl = this.target_header.length > 0 ? this.target_header : this.target;
			this.activeEl = this.anchor.closest( options.activeEl );

			//scroll and focus on section when anchor is clicked
			this.anchor.on( 'click', function( e ){
				e.preventDefault();

				window.MSR.wedecsBi.sendCustomEvent( this, {
					'ms.interactionType': 11
				} );

				$( 'html, body' ).animate( {

					scrollTop: ( self.target_offset - options.scrollOffsetTop )

				}, 500, function(){
					//on animation complete
					//unfocus link
					$( this ).blur();
					//focus on target section
					self.focusEl.attr( 'tabindex', '0' ).css( 'outline', 'none' ).focus();
				} );
			} );

			//remove tabindex from section element after focus is removed
			//to prevent users from tabbing back to it
			this.focusEl.on( 'focusout', function( e ){
				$( this ).removeAttr( 'tabindex' );
			} );

			function calculateOffset() {
				self.target_offset = self.target.offset().top;
			}

			//calculate offset
			$win.on( 'load', calculateOffset() );

			//recalculate offset
			$win.resize( debounce( calculateOffset, 400 ) );
		};

		sectionObj.prototype.calculateOffset = function() {
			this.target_offset = this.target.offset().top;
		};

		return {
			init: init
		};
	} )( jQuery );
} )();
